import '../__generated__/styles/utils.css';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import clsx from 'clsx';
import { useTheme } from '@paypalcorp/pp-react-theme';

var styles = {"ppvx_screenreader":"ppvx_screenreader___1-5-4","ppvx_body--no-scrolling":"ppvx_body--no-scrolling___1-5-4","ppvx_visible-only-in-context":"ppvx_visible-only-in-context___1-5-4","ppvx_text-ellipsis":"ppvx_text-ellipsis___1-5-4","ppvx_shimmer":"ppvx_shimmer___1-5-4","ppvx_shimmer__animation":"ppvx_shimmer__animation___1-5-4","ppvx_shimmer--inverse":"ppvx_shimmer--inverse___1-5-4","ppvx_shimmer__defaults":"ppvx_shimmer__defaults___1-5-4","ppvx_elevation--level1":"ppvx_elevation--level1___1-5-4","ppvx_elevation--level2":"ppvx_elevation--level2___1-5-4","ppvx_elevation--level2--above":"ppvx_elevation--level2--above___1-5-4","ppvx_elevation--level3":"ppvx_elevation--level3___1-5-4","ppvx_elevation--level4":"ppvx_elevation--level4___1-5-4","ppvx_elevation--level5":"ppvx_elevation--level5___1-5-4","ppvx--v2":"ppvx--v2___1-5-4","ppvx--v1":"ppvx--v1___1-5-4","ppvx_motion__animation-timing":"ppvx_motion__animation-timing___1-5-4","ppvx_motion__transition-timing":"ppvx_motion__transition-timing___1-5-4"};

var _excluded = ["as", "className", "children"];

var ScreenReaderContent = function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(as, _extends({
    className: clsx(styles.ppvx_screenreader, className)
  }, rest), children);
};

var Shimmer = function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      isInverse = _ref.isInverse,
      className = _ref.className,
      _ref$hasStyleDefaults = _ref.hasStyleDefaults,
      hasStyleDefaults = _ref$hasStyleDefaults === void 0 ? true : _ref$hasStyleDefaults,
      children = _ref.children;
  var classes = clsx(styles.ppvx_shimmer, isInverse && styles['ppvx_shimmer--inverse'], hasStyleDefaults && styles.ppvx_shimmer__defaults, className);
  return /*#__PURE__*/React.createElement(as, {
    className: classes
  }, /*#__PURE__*/React.createElement(ScreenReaderContent, {
    as: "span"
  }, children));
};

var _excluded$1 = ["level", "className", "children", "theme"];

var Elevation = function (_ref) {
  var level = _ref.level,
      className = _ref.className,
      children = _ref.children,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, _excluded$1);

  var _theme = useTheme('Elevation', theme);

  var classes = clsx(styles["ppvx_elevation--level".concat(level)], _theme && _theme === 'v2' && styles['ppvx--v2'], className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, rest), children);
};

var PREFIX_DEFAULT = 'ppui';
var ppuiUniqueIdCounter = {};
/**
 * Generates an unique ID.
 * If prefix is passed, the function prepends the prefix with the ID.
 *
 * @param {string} prefix The value to prefix with the ID.
 * @returns {string} The unique ID.
 */

function uniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PREFIX_DEFAULT;

  if (!ppuiUniqueIdCounter[prefix]) {
    ppuiUniqueIdCounter[prefix] = 0;
  }

  var id = ++ppuiUniqueIdCounter[prefix];
  return prefix === PREFIX_DEFAULT ? "".concat(id) : "".concat(prefix).concat(id);
}

var _excluded$2 = ["className"],
    _excluded2 = ["className"];
var withAnimation = function (WrappedComponent) {
  var WCAnimation = function (_ref) {
    var className = _ref.className,
        rest = _objectWithoutProperties(_ref, _excluded$2);

    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      className: clsx(styles['ppvx_motion__animation-timing'], className)
    }, rest));
  };

  WCAnimation.displayName = 'withAnimation';
  return WCAnimation;
};
var withTransition = function (WrappedComponent) {
  var WCTransition = function (_ref2) {
    var className = _ref2.className,
        rest = _objectWithoutProperties(_ref2, _excluded2);

    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      className: clsx(styles['ppvx_motion__transition-timing'], className)
    }, rest));
  };

  WCTransition.displayName = 'withTransition';
  return WCTransition;
};

export { Elevation, ScreenReaderContent, Shimmer, uniqueId, withAnimation, withTransition };
